<template>

	<!-- Page Container -->
	<div class="page-container">
		
		 <!-- <div class="smoke overlay" :class="smokeVisible ? 'visible' : ''">
	    <video src="https://player.vimeo.com/external/403725192.sd.mp4?s=d4d6342491e6938b0d74981dbdeb32b845f562da&profile_id=164" playsinline="true" autoplay="true" loop="true" id="smoke-out" preload="auto"/>
    </div> -->
    
	  <!-- Main -->
	  <main class="main" :class="livestreamtoggle === 'on' && 'livestream-engaged'">

		  	<aside v-if="livestreamtoggle == 'on'" id="livestream-toggle"></aside>

	    
	    	<aside id="schedule-toggle" :class="[open ? 'active grow width' : '', livestreamlocation == 'Full Screen' ? '':'']" @click="handleClick"  style="z-index: 999;">
				<span v-if="!open">Schedule</span>
			</aside>

			<aside class="mute-toggle" @click="$store.commit('toggleSound')"  style="z-index: 999;">
				<span v-if="!open">
					<img :src="soundOn ? require('../assets/img/mute.svg') : require('../assets/img/unmute.svg') " />
				</span>
			</aside>
	    		
	    <!-- Hero - Radical Broadcast -->
			

		<!-- Hero - Livestream -->
			<template v-if="livestreamtoggle == 'on'">
				<template v-if="livestreamlocation == 'Radical Broadcast' || livestreamlocation == 'Full Screen'">
				<div class="livestream-rb" :class="[open ? 'sched-open' : '', livestreamlocation == 'Full Screen' ? 'fs':'']">
				<Livestream />
				  <div id="schedule" :class="open ? 'is-open' : ''">
					  <article>
						  <div class="wrap schedule-header">
			          <header>
			            <h2>Live Radical Broadcast</h2>
			            <hr>
			          </header>
				      </div>
						  
						  <div class="wrap schedule-wrap">
							  
							  <main>
									
							      <h2 class="text-extended"><strong>{{livebroadcasttitle}}</strong></h2>
							      <prismic-rich-text :field="livebroadcastcontent" class="collection-description"/>
							      <prismic-link :field="readmorelink" class="cta btn">
							      	<span>Read More</span>
							      </prismic-link>
								</main>
							
						  </div>
						  
					  </article>
				  </div>
				 </div>
			</template>
		</template>
			<template v-else>
				<RadicalBroadcast/>
			</template>
			<div v-if="livestreamtoggle !== 'on'" class="ticker bg-black loaded rb-ticker" data-title="Radical Broadcast" style="background-color: black;color: white!important;">
				<div>
					<!-- {{ activeVideo.primary.ticker_text}} -->
				    <marquee-text :duration="60">
						<template v-if="activeVideo">
							<template v-if="activeVideo.primary.ticker_text.length">
								<template v-for="(item, index) of activeVideo.primary.ticker_text">
									<span 
										:key="item.text" 
										class="ticker-item fs-normal"
										:class="[
											item.spans.length && item.spans[0].type === 'strong' && 'text-extended text-bold', 
											item.spans.length && item.spans[0].type === 'em' && 'text-italics'
										]"
									>
										{{ item.text }}
									</span>
									<span :key="index">{{ " • " }}</span>
								</template>
							</template>
							<template v-else>
								<h3 class="ticker-item fs-normal">Live <span class="text-extended">Broadcast</span></h3> 
				      			<span class="ticker-item performa fs-normal">Performa</span>
								<span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
				      			<span class="text-condensed ticker-item performa fs-normal" v-if="activeVideo">
									{{ activeVideo.primary.program_artist }} 
									<span class="text-extended">
										{{ activeVideo.primary.program_title }}
									</span>
								</span>
				      			<span class="ticker-item performa fs-normal">Performa</span>
							</template>
						</template>
				    </marquee-text>
				</div>
			</div>
			<div v-if="livestreamtoggle === 'on'" class="ticker bg-black loaded rb-ticker" data-title="Radical Broadcast" style="background-color: black;color: white!important;">
				<div>
					<!-- {{ activeVideo.primary.ticker_text}} -->
				    <marquee-text :duration="60">
						<template v-if="livestreamTickerText">
							<template v-if="livestreamTickerText.length">
								<template v-for="(item, index) of livestreamTickerText">
									<span 
										:key="index" 
										class="ticker-item fs-normal"
										:class="[
											item.spans.length && item.spans[0].type === 'strong' && 'text-extended text-bold', 
											item.spans.length && item.spans[0].type === 'em' && 'text-italics'
										]"
									>
										{{ item.text }}
									</span>
									<span :key="index">{{ " • " }}</span>
								</template>
							</template>
							<template v-else>
								<h3 class="ticker-item fs-normal">Live <span class="text-extended">Broadcast</span></h3> 
				      			<span class="ticker-item performa fs-normal">Performa</span>
								<span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
				      			<span class="text-condensed ticker-item performa fs-normal" v-if="activeVideo">
									{{ activeVideo.primary.program_artist }} 
									<span class="text-extended">
										{{ activeVideo.primary.program_title }}
									</span>
								</span>
				      			<span class="ticker-item performa fs-normal">Performa</span>
							</template>
						</template>
				    </marquee-text>
				</div>
			</div>
		<!-- SUPPORT SECTION -->
		<template v-if="support">
			<div 
				class="ticker bg-green loaded ticker-right" 
				data-title="Join Us"
				:style="{
					backgroundColor: support.tickerBackgroundColor || 'black'
				}"
			>
        		<div>
            		<marquee-text :duration="60">
              			<template v-if="support.tickerText.length">
								<template v-for="(item, index) of support.tickerText">
									<template v-if="item.type === 'heading3'">
										<h3 class="ticker-item fs-normal" :key="item.text + index" style="padding-left: 8px">
											<span 
												class="text-extended"
												:style="{
													color: support.tickerColor || 'white'
												}"
											>
												{{ item.text }}
											</span>
										</h3>
									</template>
									<template v-else-if="item.type !== 'heading3'">
										<span 
											:key="item.text + index" 
											class="ticker-item fs-normal"
											:style="{
												color: support.tickerColor || 'white'
											}"
											:class="[
												item.spans.length && item.spans[0].type === 'strong' && 'text-extended text-bold', 
												item.spans.length && item.spans[0].type === 'em' && 'text-italics'
											]"
										>
											{{ item.text }}
										</span>
									</template>
								</template>
							</template>
            		</marquee-text>
        		</div>
    		</div>
			<div 
				class="wrap wrap-half homepage-button-wrapper"
				:style="[
					{
						backgroundColor: support.backgroundColor ? support.backgroundColor : ''
					},
					{
						color: support.color ? support.color : ''
					}
				]"
			>
				<div style="max-width:960px;margin-left:auto;margin-right:auto;">
					<p class="header-p text-extended">{{ $prismic.richTextAsPlain(support.text) }}</p>
				</div>
	    		<prismic-link 
					:field="support.link" 
					class="btn btn--full" 
					style="text-align: center"
					:style="[
						{
							color: support.color ? support.color : ''
						},
						{
							borderColor: support.color ? support.color : ''
						}
					]"
				>
					{{ support.linkText }}
				</prismic-link>
			</div>
		</template>
	  	<!-- ABOUT US -->
		<template v-if="aboutUs">
			<div 
				class="ticker loaded rb-ticker" 
				data-title="Radical Broadcast"
				:style="{
					backgroundColor: aboutUs.tickerBackgroundColor || 'black'
				}"
			>
				<div>
				    <marquee-text :duration="60">
						<template v-if="aboutUs.tickerText.length">
								<template v-for="(item, index) of [...aboutUs.tickerText, ...aboutUs.tickerText]">
									<span 
										:key="item.text + index" 
										class="ticker-item fs-normal"
										:style="{
											color: aboutUs.tickerColor || 'white'
										}"
										:class="[
											item.spans.length && item.spans[0].type === 'strong' && 'text-extended text-bold', 
											item.spans.length && item.spans[0].type === 'em' && 'text-italics'
										]"
									>
										{{ item.text }}
									</span>
								</template>
							</template>
				    </marquee-text>
				</div>
			</div>
			<div
				class="wrap homepage-button-wrapper"
				:style="[
					{
						backgroundColor: aboutUs.backgroundColor ? aboutUs.backgroundColor : ''
					},
					{
						color: aboutUs.color ? aboutUs.color : ''
					}
				]"
			>
				<prismic-rich-text 
					:field="aboutUs.text" 
					:style="{
						color: aboutUs.color || 'black'
					}"
				/>

				<div class="wrap wrap-half grid-container c2 about-us-links" v-if="aboutUs.links.length">
					<template v-for="(link, index) of aboutUs.links">
						<prismic-link 
							:key="link.link_text + index"
							:field="link.link" 
							class="btn btn--full text-extended" 
							style="text-align: center"
							:style="[
								{
									color: aboutUs.color ? aboutUs.color : ''
								},
								{
									borderColor: aboutUs.color ? aboutUs.color : ''
								}
							]"
						>
							{{ link.link_text }}
						</prismic-link>
					</template>
				</div>
			</div>
		</template>

		<!-- EDITIONS -->
		<template v-if="editions && products.length > 0">
			<div 
				class="ticker bg-white loaded ticker-right" 
				data-title="Join Us" 
				:style="{
					backgroundColor: editions.tickerBackgroundColor || 'white'
				}"
			>
        		<div>
            		<marquee-text :duration="60">
              			<template v-if="editions.tickerText.length">
								<template v-for="(item, index) of editions.tickerText">
									<template v-if="item.type === 'heading3'">
										<h3 class="ticker-item fs-normal" :key="item.text + index" style="padding-left: 8px">
											<span 
												class="text-extended"
												:style="{
													color: editions.tickerColor || 'white'
												}"
											>
												{{ item.text }}
											</span>
										</h3>
									</template>
									<template v-else-if="item.type !== 'heading3'">
										<span 
											:key="item.text + index" 
											class="ticker-item fs-normal"
											:style="{
												color: editions.tickerColor || 'white'
											}"
											:class="[
												item.spans.length && item.spans[0].type === 'strong' && 'text-extended text-bold', 
												item.spans.length && item.spans[0].type === 'em' && 'text-italics'
											]"
										>
											{{ item.text }}
										</span>
									</template>
								</template>
							</template>
            		</marquee-text>
        		</div>
    		</div>
			<!-- SHOP -->
			<article 
				class="shop-container shop wrap" 
				v-if="products.length > 0" 
				:style="[
					{
						backgroundColor: editions.backgroundColor ? editions.backgroundColor : ''
					},
					{
						color: editions.color ? editions.color : ''
					}
				]">

				<div>
					<div class="shop-header">
						<h1>{{ editions.title }}</h1>
					</div>
					<div class="section-description">
						<prismic-rich-text :field="editions.description" />
					</div>
				</div>

				<div class="grid-container c4 products-container">

					<div class="product-card" v-for="product of products" :key="product.id">
						<div class="pgi">
							<img :src="product.selectedImage" class="product-card-image" />
						</div>
						<h3>{{ artistName(product.title) }}</h3>
						<span v-if="product.availableForSale" @click="redirectToProductDetailPage(product)" target="_blank" class="btn tb-btn">
							Buy Now!
						</span>
					</div>
				</div>
		 	</article>
		 </template>

		 <div class="ticker bg-blue loaded" data-title="News">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">News</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	    <!-- Events / News -->

	    <section id="events">
	        <div class="events-wrap">
				        
	            <div id="news" class="week-container wrap wrap-half active">
	                <div class="week-container-header">
	                    <h3 class="text-extended text-center text-largest"><strong>News <span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container" :class="featured_posts.length >= 4 ? 'c3' : featured_posts.length == 3 ? 'c3' : featured_posts.length == 2 ? 'c2' : 'c2'"> 
		                <NewsPost v-for="(item, index) in featured_posts" v-if="index <= 3" :key="item.id" :post="item">
		                </NewsPost>
	                </div>
									<div class="wrap wrap-half text-center">
										<router-link class="btn btn--full" to="/news">
											View More
										</router-link>
									</div>
									

	            </div>
	        </div>
	        <!-- <div class="ticker bg-blue loaded" data-title="Events">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">Events</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div> -->
	        <div class="events-wrap">
	            
	            <!-- <div class="week-container wrap wrap-half bt  active">
	                <div class="week-container-header" v-if="upcomingEventsTrue(featured_events)">
	                    <h3 class="text-extended text-center text-largest"><strong>Current and Upcoming Events<span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container c2">
		                <FeaturedPost v-for="(item, index) in featured_events" v-if="upcomingEvents(item.post_date)" :key="item.id" :post="item">
		                </FeaturedPost>
	                </div>
	            </div> -->
	            
	            <!-- <div class="week-container wrap wrap-half bt past-week-container" @click="showEvents" :class="eventsExpanded ? 'active' : ''">
	                <div class="week-container-header" v-if="recentlyPastTrue(featured_events)">
	                    <h3 class="text-extended text-center text-largest"><strong>In The Past <span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container c2">
		                <FeaturedPost v-for="(item, index) in featured_events" v-if="recentlyPast(item.post_date)" :key="item.id" :post="item">
		                </FeaturedPost>
	                </div>
	                <div class="wrap wrap-half text-center" style="padding-top:0">
					        	<router-link to="/special-events" class="btn btn--full">Special Events</router-link>
					        </div>
	            </div> -->
	        </div>

	    </section>

	    
	    <!-- Magazine -->
	    <section id="magazine">
	        <div class="ticker bg-pink loaded" data-title="Magazine">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">Magazine</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal">Magazine</span>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	        
	        
	        <div class="section-wrap magazine-wrap">
	            <div class="grid-container c2">
		            <FeaturedArticle v-for="(item, index) in featured_articles.slice(0,4)" :key="item.id" :article="item">
								</FeaturedArticle>
	            </div>
	        </div>
	        
	        
	        <div class="wrap wrap-half text-center">
	        	<router-link to="/magazine" class="btn btn--full">View All</router-link>
<!-- 	            <aside class="sponsored-by text-center text-bold fs-1">
	                <span class="text-condensed text-uppercase">With generous support from <span class="text-extended">Gucci</span></span>
	            </aside> -->
	        </div>
	    </section>
			<section id="performa19" class="bg-black">
	    	<div class="ticker ticker-right bg-white loaded" data-title="Events" style="background-color:yellow;">
	    	    <div>
	    	    	<marquee-text :duration="60">
	    	    	  <h3 class="ticker-item fs-normal">November 1 — 24, 2019</h3>
	    	    	  <span class="ticker-item performa fs-normal">Performa•19</span>
	    	    	  <span class="ticker-item fs-normal">November 1 — 24, 2019</span>
	    	    	  <span class="ticker-item performa fs-normal">Performa•19</span>
	    	    	</marquee-text>
	    	    </div>
	    	</div>
	    	    	<div style="background-color: black;color:white;font-size:1.5rem;">
	    	    	<div class="wrap" style="max-width:960px;margin-left:auto;margin-right:auto;">
	    	    		<h3 class="text-extended text-center text-largest text-uppercase"><strong>Performa 19</strong></h3>
	    	    	    <p class="header-p text-extended" style="text-align:justify;hyphens:none;">The eighth edition of the Performa Biennial once again celebrated the extraordinary vitality, inventiveness and significance of New York as a leading global performance capital of the world in three weeks of exciting programming, from November 1 — 24, 2019, at locations throughout New York City.</p>

	    	    	    <br/>
	    							<div class="homepage-button-wrapper">
	    								<a href="http://performa19.org" target="_blank" class="btn btn--full btn--white text-center" style="border: 1px solid white">Click here to view</a>
	    	    				</div>
	    				</div>
	    	    </div>
	    </section>
	  </main>
	</div>

</template>

<style>
.btn--full{
	display: block;
	border: 1px black solid;
	border-radius: 16px;
	margin: 1em auto;
}

.btn{
	display: inline-block;
	border: 1px black solid;
	border-radius: 16px;
	margin: 1em auto;
	padding: 16px;
}

</style>

<script>	
import RadicalBroadcast from '../components/RadicalBroadcast.vue'
import FeaturedBanner from '../components/FeaturedBanner.vue'
import Carousel from '../components/Carousel.vue'
import FeaturedPost from '../components/FeaturedPost.vue'
import NewsPost from '../components/NewsPost.vue'
import FeaturedArticle from '../components/FeaturedArticle.vue'

import Livestream from '../components/Livestream.vue'

// shop config
import config from '../../config.js';
import ShopifyClient from '../services/ShopifyClient'

import prismicDOM from 'prismic-dom'
import moment from 'moment'

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'Homepage',
  components: {
	  RadicalBroadcast,
	  FeaturedBanner,
	  Carousel,
	  FeaturedPost,
	  NewsPost,
	  FeaturedArticle,
	  Livestream,
  },
  data () {
    return {
		products: [],
	    title: null,
	    description: null,
	    seo_image: null,
	    today: null,
	    
      fields: {
				title: null,
				donate_text: null,
				donate_link: null,
				byline: null
      },
      hero_slices: [],
      featured_events: [],
      featured_posts: [],
      featured_articles: [],
      eventsExpanded: false,
      smokeVisible: false,
      livestreamtoggle: '',
      livestreamlocation: '',
      livebroadcasttitle: null,
	  livebroadcastcontent: null,
	  livestreamTickerText: null,
	  readmorelink: null,
	  editions: null,
	  support: null,
	  aboutUs: null,
	  contentCreated: false
    }
  },
  computed: {
    open () {
      return this.$store.state.schedOpen
	},
	soundOn () {
		return this.$store.state.soundOn;
	},
	activeVideo () {
		console.log(this.$store.state.activeVideo)
		return this.$store.state.activeVideo;
	}
  },
  watch: {
  	open: function (open) {
  		console.log('sched watcher')
	},

	activeVideo (newVal) {
		console.log('new active video')
	}
  },
	methods: {
		// scroll () {
    //   window.onscroll = () => {
    //     if ( document.documentElement.scrollTop > window.innerHeight ) {
    //     	var ele = document.getElementById('smoke-out');
		// 			  ele.play();
	  //       this.smokeVisible = true;
         
    //     } else {
	  //       this.smokeVisible = false
    //     }
    //  	}
  	// },
		handleClick () {
			this.$store.dispatch('toggleSched');
    	},
    			closeSched () {
    	    	this.$store.dispatch('toggleSched')
    	    },
		updateToday() {
      this.updateToday = moment().format('MM•D•YYYY');
    },
		thisWeek(date) {
			var yesterday = moment().subtract(1, 'days');
			var weekAhead = yesterday.clone().add(30, 'days');
			if (moment(date).isBetween(yesterday, weekAhead)) {
				return true;
			}
		},
		upcomingEvents(date) {
			var today = moment();
			if (moment(date).isAfter(today)) {
				return true;
			}
		},
		upcomingEventsTrue(array) {
			var today = moment();
			var yesterday = moment().subtract(1, 'days');
			var arrayLength = array.length;
			var upcoming = [];
			
			for (var i=0; i<arrayLength; i++) {
				if (moment(array[i].post_date).isAfter(yesterday)) {
					upcoming.push(array[i]);
				}
	    } 
	    	    
	    if (upcoming.length > 0) {
		  		return true  
	    } else { return false }
		},
		recentlyPast(date) {
			var today = moment();
			if (moment(date).isBefore(today)) {
				return true;
			}
		},
		recentlyPastTrue(array) {
			var today = moment();
			var arrayLength = array.length;
			var past = [];
			
			for (var i=0; i<arrayLength; i++) {
				if (moment(array[i].post_date).isBefore(today)) {
					past.push(array[i]);
				}
	    } 
	    	    
	    if (past.length > 0) {
		  		return true  
	    } else { return false }
		},
		getPosts () {				
			this.$prismic.client.query(
			  this.$prismic.Predicates.at('document.type', 'post'),
			  { orderings : '[my.post.date desc]', pageSize: 3 } // limit fetch to only 3 articles on HOMEPAGE
			).then((response) => {
				this.featured_posts = response.results;
			})
	  },
		getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
				console.log(document)
			  	this.title = document.data.seo_title;
			  	this.description = 	document.data.seo_description;
			  	this.seo_image = document.data.seo_image.url;
			  	this.hero_slices = document.data.body;
			  	this.featured_events = document.data.featured_posts;
			  	this.featured_articles = document.data.featured_articles;
			  	this.today = moment();
				  this.livestreamtoggle = document.data.livestream
				// this.livestreamtoggle = 'on';
				//   console.log(document.data.livestream)
				this.livestreamTickerText = document.data.livestream_ticker_text
			  	this.livestreamlocation = document.data.livestreamlocation
			  	this.livebroadcasttitle = document.data.live_broadcast_title
			  	this.livebroadcastcontent = document.data.live_broadcast_content
			  	this.readmorelink = document.data.read_more_link
				this.id = document.data.livestream_id;
				console.log(document.data)
				this.editions = { 
					title: document.data.editions_title, 
					description: document.data.editions_description, 
					backgroundColor: document.data.editions_background_color,
					color: document.data.editions_text_color,
					tickerText: document.data.editions_ticker_text,
					tickerColor: document.data.editions_ticker_text_color,
					tickerBackgroundColor: document.data.editions_ticker_background_color
				}

				this.support = {
					text: document.data.support_text,
					link: document.data.support_link,
					linkText: document.data.support_link_text,
					backgroundColor: document.data.support_background_color,
					color: document.data.support_text_color,
					tickerColor: document.data.support_ticker_text_color,
					tickerBackgroundColor: document.data.support_ticker_background_color,
					tickerText: document.data.support_ticker_text
				}

				this.aboutUs = {
					backgroundColor: document.data.about_us_background_color,
					color: document.data.about_us_text_color,
					text: document.data.about_us_text,
					tickerBackgroundColor: document.data.about_us_ticker_background_color,
					tickerColor: document.data.about_us_ticker_text_color,
					tickerText: document.data.about_us_ticker_text,
					links: document.data.about_us_links
				}
				});
				this.$prismic.client.getSingle('footer').then((document) => {
          this.fields.donate_text = document.data.donate_text;
					this.fields.donate_link = document.data.donate_link;
					this.fields.byline = document.data.byline;
        });
	  },
	  toggleBodyClass(addRemoveClass, className) {
	    const el = document.body;
	    if (addRemoveClass === 'addClass') {
	      el.classList.add(className);
	    } else {
	      el.classList.remove(className);
	    }
	  },
	  showEvents() {
		  this.eventsExpanded = true
	  },

	  artistName (title) {
		const name = title;
		return name ? name : title
		// return title.split(',')[1]
	  },

	  redirectToProductDetailPage (product) {
			let url = "https://performa-artist-editions.myshopify.com/products/";
			switch (product.title) {
				case "Barbara Kruger, Untitled (Vase)":
					url += 'barbara-kruger-vase';
					break;
				case "Cindy Sherman, Untitled (Vanity Mirror)":
					url += 'cindy-sherman-mirror';
					break;
				case "Kia LaBeija x Taína Larot, Ring of Fire; The List is Endless":
					url += 'kia-labeija-art-demands';
					break;
				case "Kia LaBeija, December 1st":
					url += 'kia-labieja-december-1st';
					break;
				case "Kia LaBeija, Untitled (The Spirals that lead to Nowhere)":
					url += 'kia-labeija-duet';
					break;
				case "Korakrit Arunanondchai, Mother Pillow":
					url += 'korakrit-arunondchai-body-pillow';
					break;
				case "Laurie Simmons X David Bers Architects, FlashCube":
					url += 'flashcube-laurie-simmons-x-david-bers';
					break;
				case "Michèle Lamy X Katerina Jebb, Untitled (Plateau / Tray)":
					url += 'michele-lamy-tray';
					break;
				default:
					url += 'all-editions';
					break;
				
			}
			window.open(url, '_blank');
		}
	},
	created () {
	  this.getContent();
		this.getPosts();
		this.updateToday = moment().format('MM•D•YYYY');
		if (!this.$store.state.schedOpenedOnMount && window.innerWidth >= 640) {
			// setTimeout(() => {		
			// 	this.$store.dispatch('toggleSched');
			// }, 2000);
		}
	  this.contentCreated = true;
  },
  async mounted() {
	
	  
	  this.toggleBodyClass('addClass', 'template-index');
	    setTimeout(function() {
	  		toggleClass(document.body, 'addClass', 'loaded');
			}, 500);

	this.shopifyClient = new ShopifyClient(config.shopifyDomain, config.shopifyToken);

	await this.shopifyClient.allProducts(products => {
		this.products = products;
	});

  },

  destroyed() {
	  this.toggleBodyClass('removeClass', 'template-index');
  },

  metaInfo () {
	  
	  if (this.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.description;
	  }
	  	  
    return {
      title: this.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		    
		    {vmid: 'og:title', property: 'og:title', content: this.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    // The list of types is available here: http://ogp.me/#types
		    {vmid:'og:type', property: 'og:type', content: 'website'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/'},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    {vmid:'og:image', property: 'og:image', content: this.seo_image},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/'},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},
				{vmid: 'twitter:image', name: 'twitter:image', content: this.seo_image},
		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description}
		  ]
    }
  }
}
</script>

<style scoped>

	.mute-toggle {
		width: 32px; 
    	height: 32px;
    	background-color: #f8e71c;
    	border-radius: 32px;
   	 	cursor: pointer;
    	position: absolute;
    	right: 1rem;
		top: 80px;
		opacity: 1;
		transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	@media screen and (min-width: 1024px) {
		.mute-toggle {
			top: 96px;
		}
	}

	.mute-toggle span {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
	}

	.mute-toggle span img {
		margin: 0 auto;
		vertical-align: middle;
		padding: 0.2rem;
	}

	#schedule-toggle:hover + .mute-toggle {
		right: 0.5rem;
	}

	.mute-toggle:hover, .mute-toggle:focus {
		background-color: #fff;
		transform: scale(1.5);
		cursor: pointer;
	}

	.mouse-paused .mute-toggle {
		  top: 32px !important;
		  opacity: 0;
	}

	.text-bold {
		font-weight: bold;
		padding-left: 8px;
		padding-right: 0px;
	}

	.text-italics {
		font-weight: normal;
		font-style: italic;
		padding: 0 4px;
	}

	.about-us-links .text-extended {
		font-family: "Lars Sans Extended", Helvetica, Arial, sans-serif;
	}

	#livestream-toggle {
		z-index: 10000000;
		position: absolute;
		top: 4.5rem;
		right: 1.5rem;
		display: block;
	}

	.mouse-paused #livestream-toggle, .mouse-paused #livestream-toggle::before, .mouse-paused #livestream-toggle::after, .mouse-paused #livestream::after {
		display: none !important;
	}

	.livestream-engaged .mute-toggle {
		display: none;
	}

	.livestream-engaged #schedule-toggle {
		right: 1.5rem;
	}

	@media screen and (max-width: 1023px) {
		#livestream-toggle {
			top: 3.5rem;
		}
	} 


	@media screen and (max-width: 959px) {
		.about-us-links {
			grid-template-columns: 100%;
		}

		#livestream-toggle {
			top: 3.5rem;
		}
	}

	@media screen and (max-width: 768px) {
		.mute-toggle {
			display: none;
		}


		#livestream-toggle:after {
			display: none !important;
		}
	}
</style>